module.exports = __webpack_public_path__ + "img/product_121.50f076b.svg";